// services
import { AxiosInstance } from 'axios';
import AxiosInstanceCreator from 'services/api';

// models
import { ReqNations, ResNations } from '../models/nation';

export class SettingAPI {
  Axios: AxiosInstance;

  constructor() {
    this.Axios = new AxiosInstanceCreator().create();
  }

  async fetchNations(request: ReqNations): Promise<ResNations> {
    return this.Axios.get(`/nation`, { params: request }).then((res) => res.data);
  }
}
